import { createContext } from 'react';

export const AuthContext = createContext(null);
export const AUTH_REDIRECT_NEXT_KEY = 'shadowland-auth-next';
